import { FC, useMemo } from 'react';
import { ROUTES } from 'src/constants/routes.const';
import { LanguagePairLearnable } from 'src/types/domain';
import { useLanguagePairContext } from 'src/context/languagePair';
import { useHref } from 'src/hooks/useHref';
import { getLearnableTitlesByTargetLang } from 'src/utils/getLearnableTitlesByTargetLang';
import { useTrackedClickHandler } from 'src/analytics/trackedClickHandler';
import { useEventPhrasebookPhraseSelected } from 'src/analytics/useEventPhrasebookPhraseSelected';
import * as S from './styles';

export type SearchData = {
  query: string;
  resultsLength: number;
};

interface Props {
  learnable: LanguagePairLearnable;
  isLoading?: boolean;
  currentPage: number;
  searchData: SearchData;
}

export const DictionaryListElement: FC<Props> = ({
  learnable,
  isLoading = false,
  currentPage,
  searchData,
}) => {
  const { learnableId, sourceValue, sourceValueSlug } = learnable;
  const { targetLanguageLocale } = useLanguagePairContext();
  const href = useHref({
    pathname: ROUTES.phrasebook.learnable,
    query: {
      learnableId,
      learnableSourceValueSlug: sourceValueSlug,
    },
  });
  const learnableTitles = useMemo(
    () => getLearnableTitlesByTargetLang({ ...learnable, kana: null }, targetLanguageLocale),
    [learnable, targetLanguageLocale],
  );

  const eventPhrasebookPhraseSelected = useEventPhrasebookPhraseSelected(
    {
      learnableTargetValue: learnable.targetValue,
      currentPage,
    },
    searchData,
  );

  const handleClick = useTrackedClickHandler(eventPhrasebookPhraseSelected);

  return (
    <S.RowWrapper key={learnableId}>
      <S.Word href={href} $isLoading={isLoading} dir="auto" onClick={handleClick}>
        {learnableTitles[0]}
      </S.Word>
      <S.Translation $isLoading={isLoading} dir="auto">
        {sourceValue}
      </S.Translation>
    </S.RowWrapper>
  );
};
